import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('upload', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: props.id + '7070702c',
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "48",
    height: "48",
    style: {
      maskType: 'alpha'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: props.colors[2]
  })), /*#__PURE__*/React.createElement("g", {
    mask: 'url(#' + props.id + '7070702c' + ')'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 24.0083V42H42V24",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 15L24 6L15 15",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9917 32V6",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  })));
});